import { TMessage, TMessageSchema } from '../../types/messages';
import { mapMessageToDeleted } from './mapMessageToDeleted';
import { mapMessageToOutgoing } from './mapMessageToOutgoing';
import { mapMessageToIncoming } from './mapMessageToIncoming';
import { isMessageDeleted } from './isMessageDeleted';

interface IUpdateMessageFromRawParams {
  existingMessage: TMessage;
  rawMessage: TMessageSchema;
}

/**
 * @description
 * Обновляет существующее сообщение данными из rawMessage.
 *
 * @param existingMessage - существующее сообщение в UI
 * @param rawMessage - сообщение с бэкенда
 * @returns обновлённое сообщение для UI
 */
export function updateMessageFromRaw({ existingMessage, rawMessage }: IUpdateMessageFromRawParams): TMessage {
  const { isOutcoming } = existingMessage;

  if (isMessageDeleted(rawMessage)) {
    return mapMessageToDeleted(existingMessage, rawMessage);
  }

  if (isOutcoming) {
    return mapMessageToOutgoing(existingMessage, rawMessage);
  }

  return mapMessageToIncoming(existingMessage, rawMessage);
}
